import PropTypes from 'prop-types';
import React from 'react';

import './WidgetPageBody.scss';

const WidgetPageBody = ({
  children,
}) => (
  <div className="WidgetPageBody">
    {children}
  </div>
);

WidgetPageBody.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
};

WidgetPageBody.defaultProps = {
  children: null,
};

export default WidgetPageBody;
